module.exports = {"640323001":"盐州路街道","640323100":"花马池镇","640323101":"大水坑镇","640323102":"惠安堡镇","640323103":"高沙窝镇","640323200":"王乐井乡","640323201":"冯记沟乡","640323202":"青山乡","640323203":"麻黄山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640323.json
// module id = 3178
// module chunks = 0